//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReportLayout', {
//        templateUrl: 'views/components/views/acReportLayout/acReportLayout.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'utilityService', 'modalService', 'acReportLayoutService', function ($stateParams, stateService, translateService, utilityService, modalService, acReportLayoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acReportLayoutKeyno = $stateParams.acreportlayout_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListAcReportLayouts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await acReportLayoutService.getAcReportLayout({ acreportlayout_keyno: acReportLayoutKeyno }))[0];

//                return loadAcReportLayouts();
//            }

//            async function loadAcReportLayouts() {
//                if (utilityService.validateParmsValue(vm.model.edit.acreportlayout_keyno, true) !== true) return;

//                return vm.model.selectListAcReportLayouts = await acReportLayoutService.listAcReportLayouts({ acreportlayout_keyno: vm.model.edit.acreportlayout_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                acReportLayoutService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();		
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
